// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Toggle search
	const searchToggle = document.querySelector('#search-toggle');
	const searchForm = document.querySelector('.search-form');
	searchToggle.addEventListener('click', (e) => {
		searchForm.classList.toggle('active');
	});

	document.addEventListener('click', (e) => {
		if (e.target != searchForm && e.target != searchToggle) {
			searchForm.classList.remove('active');
		}
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


let observedElements = document.querySelectorAll('.site-header'); // Define the elements you want to intiate an action on

const options = { //define your options
	threshold: 0.5
}

const inViewCallback = entries => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.classList.remove('scrolled');
			entry.target.classList.add('top');
		}
		else {
			entry.target.classList.add('scrolled');
			entry.target.classList.remove('top');
		}
	});
}

// create a new instance using our callback which contains our elements and actions, using the options we defined
let observer = new IntersectionObserver(inViewCallback,options);

observedElements.forEach(element => {
	observer.observe(element) // run the observer
});